import { DocumentDetailsContentSubtype } from './enums/document-details-content-subtype';
import { TimelineActionStatus } from './enums/timeline-action-status.enum';
import { TimelineActionType } from './timeline-action-type.model';

export interface TimelineAction {
    id: number;
    actionType: TimelineActionType;
    status: TimelineActionStatus;
    dataNdaTermId?: string;
    referenceItemId?: string;
    oldReferenceItemIds?: string[];
    oldReferenceItemAdditionalVersionIds?: Partial<
        Record<keyof typeof DocumentDetailsContentSubtype, string[]>
    >;
    actionReferenceId?: number;
    isSelectionFinalized?: boolean;
}

export const defaultTimelineAction: TimelineAction = {
    id: 0,
    actionType: TimelineActionType.BuyerExpressionOfInterest,
    status: TimelineActionStatus.InProgress,
};

export const defaultAdditionalOldRefIdsField = (): Partial<
    Record<keyof typeof DocumentDetailsContentSubtype, string[]>
> => {
    return {
        StaffBlinded: [],
        DvmsBlinded: [],
        Visible: [],
    };
};

export const isValidAdditionalOldRefIdsField = (
    obj: Partial<Record<keyof typeof DocumentDetailsContentSubtype, string[]>>
) => {
    if (!obj) return false;

    return !!obj.DvmsBlinded && !!obj.DvmsBlinded && !!obj.StaffBlinded;
};
